import { render, staticRenderFns } from "./devoffline.vue?vue&type=template&id=54415c06&scoped=true&"
import script from "./devoffline.vue?vue&type=script&lang=js&"
export * from "./devoffline.vue?vue&type=script&lang=js&"
import style0 from "./devoffline.vue?vue&type=style&index=0&id=54415c06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54415c06",
  null
  
)

export default component.exports